export default function noTouch() {
  if (!('ontouchstart' in document.documentElement)) {
    document.documentElement.className += ' no-touch';
  }
}
